import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.text != null && _ctx.text !== '')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "title text-field center d-flex align-center",
        style: _normalizeStyle(_ctx.formattedStyle)
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.text), 1)
      ], 4))
    : _createCommentVNode("", true)
}